import { defaultMemoize } from 'reselect';

export const getTranslationsSelector = defaultMemoize(state => state.translations && state.translations.data);

export const getTranslationsKey = defaultMemoize(state => state.user.data && state.translations.key);
export const getLocale = defaultMemoize(state => state.translations && state.translations.data && state.translations.data.locale);

